import React from 'react'
import {
  procedureNotesColumns,
} from '../../constants/ProfillingConstants'
import CustomTable from '../../shared/CustomTable'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

function ProcedureNote () {
  const { t } = useTranslation()
  const { isLoading, patientDoctorNotes } = useSelector(
    state => state?.notes
  )
  return (
    <div>
      <CustomTable
        isLoading={isLoading}
        columns={procedureNotesColumns(t)}
        data={
          patientDoctorNotes?.data?.procedure_notes?.map(data => ({
            ...data,
            createdAt: patientDoctorNotes?.created_at,
            updateAt:data?.update_at
          })) || []
        }
      />
    </div>
  )
}

export default ProcedureNote
